import { s, c } from '../val.config';

const projectSummaryLabels = s.object({
  client: s.string(),
  period: s.string(),
  services: s.string(),
  contributions: s.string(),
});

export const schema = s.object({
  projectSummaryLabels: projectSummaryLabels,
});

export default c.define('/settings/projectSummary.val.ts', schema, {
  projectSummaryLabels: {
    client: 'Kunde',
    period: 'Tid',
    services: 'Tjenester',
    contributions: 'Leveranse',
  },
});
